import { createContext } from 'react';

export type TableSection = 'body' | 'footer' | 'head' | null;

/**
 * Context used to determine if a <TableCell /> is rendered inside a <thead>, <tbody>, or <tfoot>
 */
export const TableSectionContext = createContext<TableSection>(null);
